import i18n from "i18next";
import { NumericFormat as NumberFormat } from "react-number-format";
import {
  decimalSeparator as decimalSeparatorDefault,
  thousandSeparator as thousandSeparatorDefault,
} from "../i18n";

export function NumberFormatText({
  name,
  value,
  decimalScale,
  decimalSeparator = decimalSeparatorDefault(),
  thousandSeparator = thousandSeparatorDefault(),
  prefix = "---",
}) {
  // An infinite value (MAX_SAFE_INTEGER, or the interim >900M convention) is
  // shown as the prefix ("INF"). react-number-format renders a blank field for
  // it — its numeric formatter drops the prefix on an empty value — so return
  // the prefix text directly, mirroring NumberFormatTextPDF below.
  if (value === Number.MAX_SAFE_INTEGER || value > 900_000_000) {
    return prefix;
  }

  let isInvalid =
    //INFO: Bug in JS? Number.MAX_SAFE_INTEGER can be greeter :(
    // TODO: @Alex wann sind diese Zahlen aufgefallen ?
    // value == Number.MAX_SAFE_INTEGER + 1 ||
    value == Number.MAX_SAFE_INTEGER ||
    value === undefined ||
    typeof value == "undefined" ||
    value === null ||
    isNaN(value);
  // temporary until calcs return something more usefull incase of a inf calculation
  isInvalid = !isInvalid && value > 900_000_000 ? true : isInvalid;
  let showDecimals = !isInvalid;
  return (
    <NumberFormat
      value={isInvalid ? Number.NaN : value}
      allowEmptyFormatting={isInvalid}
      fixedDecimalScale={showDecimals}
      decimalSeparator={decimalSeparator}
      thousandSeparator={thousandSeparator}
      decimalScale={decimalScale}
      displayType="text"
      type="text"
      name={name}
      prefix={isInvalid ? prefix : undefined}
      allowNegative={false}
    />
  );
}
export function NumberFormatTextPDF({
  name,
  value,
  decimalScale,
  decimalSeparator = decimalSeparatorDefault(),
  thousandSeparator = thousandSeparatorDefault(),
  prefix = "---",
}) {
  let isInvalid =
    //INFO: Bug in JS? Number.MAX_SAFE_INTEGER can be greeter :(
    // TODO: @Alex wann sind diese Zahlen aufgefallen ?
    // value == Number.MAX_SAFE_INTEGER + 1 ||
    value == Number.MAX_SAFE_INTEGER ||
    value === undefined ||
    typeof value == "undefined" ||
    value === null ||
    isNaN(value);
  // temporary until calcs return something more usefull incase of a inf calculation
  isInvalid = !isInvalid && value > 900_000_000 ? true : isInvalid;
  let showDecimals = !isInvalid;
  const locales = i18n.resolvedLanguage === "de-DE" ? "de-DE" : "en-EN";
  const sstyles =
    decimalScale !== undefined
      ? {
          style: "decimal",
          maximumFractionDigits: decimalScale,
          minimumFractionDigits: decimalScale,
        }
      : { style: "decimal" };
  return isInvalid ? prefix : new Intl.NumberFormat(locales, sstyles).format(value);
}
